export default "__VITE_ASSET__CEGxhCqY__"